/* eslint-disable no-console */
import React from 'react';
import {Trans} from 'react-i18next';
import {Text} from 'react-native';
import i18next from 'i18next';
import {isEmpty, isFunction} from 'lodash';

export const tt = (
  i18nKey: string,
  value?: React.ReactNode | (() => React.ReactNode),
  children?: React.ReactNode,
) => {
  let content: React.ReactNode | undefined;

  if (isFunction(value)) {
    try {
      content = value();
    } catch {
      content = undefined;
    }
  } else {
    content = value;
  }

  try {
    if (typeof value === 'function') {
      //If the function returns an object, assume it is interpolation values
      if (
        content &&
        typeof content === 'object' &&
        !React.isValidElement(content) &&
        !Array.isArray(content)
      ) {
        return (
          <Trans i18nKey={i18nKey} values={content as Record<string, any>} />
        );
      }

      //If it returns JSX/string/number, just return it
      return content as React.ReactNode;
    }

    if (typeof content === 'string' || typeof content === 'number') {
      return content;
    }

    // If content is a React element, return it
    if (React.isValidElement(content)) {
      return content;
    }

    // Otherwise, fallback to children
    if (React.isValidElement(children)) {
      return children;
    }

    // Last fallback
    return i18nKey;
  } catch (err) {
    console.warn('SafeTrans crashed, falling back:', err);

    if (typeof content === 'string' || typeof content === 'number') {
      return <Text>{content}</Text>; //Wrap in <Text> instead of <>{...}</>
    }

    return <Text>{i18nKey}</Text>; //Same here
  }
};

// The `value` passed into this function must not be a translation template.
export const ts = (key: any, value: any) => {
  return i18next.t(key, value);
};

export const getPrefixedEffect = (effect: any, prefix: any) => {
  return (key: any, value: any) =>
    effect(`${isEmpty(prefix) ? '' : `${prefix}.`}${key}`, value);
};
